(function () {
  'use strict';

  angular.module('app').component('hotelContentPage', HotelContentPageComponent());

  function HotelContentPageComponent() {
    return {
      bindings: {},
      controller: HotelContentDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotel-contents/hotel-content-page.component.html',
    };
  }

  HotelContentDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'LanguageService',
    'HotelContentService',

    // Angular downgraded service
    'sessionService',
  ];

  function HotelContentDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    LanguageService,
    HotelContentService,

    // Angular downgraded service
    sessionService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_hotel_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.hotelId = $routeParams.hotelId; // optional from modal
    vm.websiteId = $routeParams.WSID;

    // Methods
    vm.onHotelContentSaved = onHotelContentSaved;
    vm.onHotelContentCanceled = onHotelContentCanceled;

    // Initializers
    getLanguages();
    // getHotelContent();

    function getLanguages() {
      const websiteStored = sessionService
        .getSelectedAccountCompany()
        .websites.find((x) => x.id === vm.websiteId);

      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        const languages = data.items;

        vm.defaultLanguage = languages.find((x) => x.id === websiteStored.language_id).lang; // use .lang
        vm.additionalLanguages = languages
          .filter((x) => websiteStored.language_ids.includes(x.id))
          .filter((y) => y.id !== websiteStored.language_id);

        // vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        // vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getHotelContent();
      });
    }

    function getHotelContent() {
      if (itemId) {
        //Edit
        vm.loadingItem = true;
        HotelContentService.getHotelContent(itemId, vm.defaultLanguage).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onHotelContentSaved(item) {
      $location.path(`/hotel_contents/${item.id}`).search({ WSID: vm.websiteId });
    }

    function onHotelContentCanceled() {
      $location.path(`/hotel_contents`).search({ WSID: vm.websiteId });
    }
  }
})();
